import theme from "@/styles/theme";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import PersonIcon from "@mui/icons-material/Person";
import { Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/system";
import Link from "next/link";
import { useRouter } from "next/router";
import { LikeSongButton } from "../LikeSongButton";
import { ShareSong } from "../ShareSong";

export const BandMessageShareLikeButtons = ({
  liked,
  song,
  overlay = false,
  playlistGrid = false,
  playlistSmall = false,
  colorSecondary = false,
  actualTrack,
}) => {
  const router = useRouter();

  return (
    <Grid
      item
      sx={{
        display: overlay ? { xs: "block" } : { xs: "none", lg: "block" },
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          transform: playlistGrid ? "" : "translateX(-.75rem)",
          "& .MuiIconButton-root": {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: colorSecondary
              ? theme.palette.secondary.main
              : theme.palette.common.white,
            color: colorSecondary
              ? theme.palette.secondary.main
              : theme.palette.common.white,
            borderRadius: "0",
            height: "2.5rem",
            width: "2.5rem",
            transition: "all .2s ease-in-out",
            p: 0,
            "&:hover": {
              backgroundColor: theme.palette.common.white,
              "& .MuiSvgIcon-root": {
                color:
                  actualTrack?.id === song?.id
                    ? theme.palette.primary.main
                    : theme.palette.secondary.main,
              },
            },
          },
          "& .MuiSvgIcon-root": {
            fontSize: 24,
          },
        }}
      >
        {!playlistSmall && (
          <>
            <Link href={`/musik/${song?.band?.slug}`} passHref legacyBehavior>
              <IconButton
                className="iconbutton"
                aria-label="Band Profil aufrufen"
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 28,
                  },
                }}
              >
                <PersonIcon />
              </IconButton>
            </Link>
            <Tooltip
              title={
                song?.band?.allow_messages && song?.band?.verified
                  ? "Nachricht schreiben"
                  : "Diese Band möchte keine Nachrichten empfangen"
              }
            >
              <span>
                <Link
                  href={`/secure/chat/new?band=${song?.band?.slug}`}
                  passHref
                  legacyBehavior
                >
                  <IconButton
                    onClick={() => {
                      router.push(`/secure/chat/new?band=${song?.band?.slug}`);
                    }}
                    aria-label="Nachricht schreiben"
                    disabled={
                      !song?.band?.allow_messages || !song?.band?.verified
                    }
                  >
                    <ChatBubbleIcon />
                  </IconButton>
                </Link>
              </span>
            </Tooltip>
          </>
        )}
        <Box
          sx={{
            "& .MuiIconButton-root": {
              borderColor: colorSecondary
                ? actualTrack?.id === song?.id
                  ? theme.palette.common.white
                  : theme.palette.secondary.main
                : theme.palette.common.white,
              "&:hover": {
                backgroundColor: "transparent",
              },
            },
            "& .MuiSvgIcon-root": {
              fill: colorSecondary
                ? actualTrack?.id === song?.id
                  ? theme.palette.common.white
                  : theme.palette.secondary.main
                : theme.palette.common.white,
              "&:hover": {
                backgroundColor: "transparent",
              },
            },
          }}
        >
          <ShareSong song={song} />
        </Box>
        <Box
          sx={{
            "& .MuiButton-root": {
              height: "2.5rem",
              width: "2.5rem",
              "&:hover": {
                "&::before": {
                  backgroundColor: "transparent",
                },
              },
              "& .MuiSvgIcon-root": {
                fontSize: "2.625rem !important",
                transform: "translateY(0.0625rem)",
                "& #likeicon-heart": {
                  fill: colorSecondary
                    ? actualTrack?.id === song?.id
                      ? theme.palette.common.white
                      : theme.palette.secondary.main
                    : theme.palette.common.white,
                },
                "& #likeicon-border": {
                  fill: colorSecondary
                    ? actualTrack?.id === song?.id
                      ? theme.palette.common.white
                      : theme.palette.secondary.main
                    : theme.palette.common.white,
                },
              },
            },
          }}
        >
          <LikeSongButton
            actualTrack={actualTrack}
            track={song}
            colorSecondary={colorSecondary}
          />
        </Box>
      </Stack>
    </Grid>
  );
};
